import { useCallback, useState } from 'react';

type ToggleIndexResult = {
  activeIndex: number | string | null;
  toggleIndex: (index: number | string) => void;
};

export const useToggleIndex = (): ToggleIndexResult => {
  const [activeIndex, setActiveIndex] = useState<number | string | null>(null);
  const toggleIndex = useCallback(
    (nextIndex: number | string) => {
      setActiveIndex((currentIndex) =>
        nextIndex !== currentIndex ? nextIndex : null,
      );
    },
    [setActiveIndex],
  );

  return { activeIndex, toggleIndex };
};
